import {
  Alert,
  Autocomplete,
  Avatar,
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import AnDateTimePicker from '../../../../components/DateTime/DateTimePicker'

const MeetingInfo = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  type,
  setType,
  location,
  setLocation,
  invitees,
  setInvitees,
  inviteeOptions,
}) => {
  return (
    <Paper sx={{ padding: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="title2">Create New Meeting</Typography>
        </Grid>
        <Grid item xs={12} lg={4}>
          <AnDateTimePicker
            label="Start"
            date={startDate}
            onChange={(newDate) => setStartDate(newDate)}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <AnDateTimePicker
            label="Finish"
            date={endDate}
            onChange={(newDate) => setEndDate(newDate)}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <FormControl fullWidth required>
            <InputLabel>Meeting Type</InputLabel>
            <Select
              value={type}
              onChange={(e) => setType(e.target.value)}
              label="Meeting Type"
            >
              <MenuItem value="Governance">Governance</MenuItem>
              <MenuItem value="Operational">Operational</MenuItem>
              <MenuItem value="Event Planning">Event Planning</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            label="Location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            name="meeting-location"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} lg={8}>
          <Autocomplete
            value={invitees}
            options={inviteeOptions}
            getOptionLabel={(opt) => opt?.firstName + ' ' + opt?.lastName}
            multiple
            renderTags={(options) => (
              <Box display="flex" gap={1}>
                {options.map((opt) => {
                  if (opt) {
                    return (
                      <Box
                        display="flex"
                        gap={1}
                        key={opt?._id ?? 1}
                        border="solid 1px rgba(0,0,0,0.24)"
                        borderRadius={1}
                        padding={1}
                      >
                        <Avatar
                          src={opt?.photograph}
                          sx={{ width: 24, height: 24 }}
                        />
                        <Typography>
                          {opt?.firstName} {opt?.lastName}
                        </Typography>
                      </Box>
                    )
                  }
                })}
              </Box>
            )}
            renderOption={(props, option) => {
              return (
                <Box display="flex" gap={1} {...props}>
                  <Avatar
                    src={option?.photograph}
                    sx={{ width: 24, height: 24 }}
                  />
                  <Typography>
                    {option?.firstName} {option?.lastName}
                  </Typography>
                </Box>
              )
            }}
            onChange={(e, value) => setInvitees(value)}
            renderInput={(params) => <TextField {...params} label="Invitees" />}
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

export default MeetingInfo
